export enum QuestionDifficultyPoints {
  EASY = 25,
  NORMAL = 50,
  HARD = 75,
}
